import { Skeleton } from '@ui/Skeleton';

import s from './PromotionPackageCard.sss';

export const PromotionPackageCardSkeleton = () => (
  <div className={s.root}>
    <div className={s.main}>
      <Skeleton
        type="circle"
        width="40px"
        height="40px"
        align="center"
      />
      <br />
      <div className={s.title}>
        <Skeleton
          width="40%"
          height="16px"
          align="center"
        />
      </div>
      <div className={s.description}>
        <Skeleton
          width="80%"
          height="12px"
          align="center"
        />
      </div>
      <div className={s.priceBlock}>
        <Skeleton
          width="20%"
          height="32px"
          align="center"
        />
      </div>
    </div>
    <ul className={s.benefitsList}>
      {new Array(3).fill(null).map((_, i) => (
        <li
          key={i}
          className={s.benefitsItem}
        >
          <div className={s.benefitsIcon}>
            <Skeleton
              type="circle"
              width="24px"
              height="24px"
            />
          </div>
          <Skeleton
            width="70%"
            height="16px"
          />
        </li>
      ))}
    </ul>
  </div>
);
